//@DEPRECATED
import { Modal, PrimaryButton } from '@cb/apricot-react';
import { FC } from 'react';

import { cleanMultiLines } from 'src/utils';

interface ViewVettingNotesModalProps {
  isOpen?: boolean;
  onClose: VoidFunction;
  currentAdminVettingNotes: string;
}

interface INote {
  user: string;
  datetime: string;
  lines: string[];
}

const ViewVettingNotesModal: FC<ViewVettingNotesModalProps> = ({ isOpen, onClose, currentAdminVettingNotes }) => {
  const parsed: string[] = currentAdminVettingNotes && currentAdminVettingNotes.length > 0 ? currentAdminVettingNotes.split('AdminUser-') : [];

  const notes: INote[] = [];
  for (const item of parsed) {
    if (item === '') continue;
    const [details, message] = item.split(' : ', 2);
    const [user, datetime] = details.split(' at ', 2);
    const lines = message.split('\n');

    const note: INote = {
      user: user,
      datetime: datetime,
      lines: cleanMultiLines(lines)
    };
    notes.push(note);
  }

  return (
    // @ts-ignore
    <Modal
      title="Review Internal Vetting Notes"
      actions={[
        <PrimaryButton key="close" onClick={onClose}>
          Close
        </PrimaryButton>,
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>
      {notes.length > 0 &&
        (
          notes.map((note) => {
            return <div style={{ marginBottom: '10px' }}>
              <div style={{ fontWeight: 500, backgroundColor: '#f6f6f6', borderRadius: '5px', padding: '5px 5px' }}>{note.lines.map((line) => <div>{line}&nbsp;</div>)}</div>
              <div style={{ fontSize: 11, color: '#7b7b7b' }}>
                <span style={{ fontStyle: 'italic' }}>{note.user || ''}</span>
                &nbsp;@&nbsp;
                {new Date(note.datetime).toLocaleString() || ''}
              </div>
              <div ></div>
            </div>;
          })
        )
      }
    </Modal>
  );
};

export default ViewVettingNotesModal;
